import { z } from 'zod'

// The contract's `format: binary` PDF is generated as a string, so the real Blob and its MIME type are validated here.
export const pdfBlobSchema = z
  .lazy(() => (typeof Blob === 'undefined' ? z.never() : z.instanceof(Blob)))
  .refine((blob) => blob.type === 'application/pdf', {
    error: 'Blob type must be application/pdf'
  })
